import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import CustomerGreenClassificationService from "../../services/CustomerGreenClassificationService";
import { Mode } from "./CustomerGreenClassificationPage";
import { CustomerGreenClassificationModel } from "../../models/CustomerGreenClassificationModel";
// import { statusOptions } from "../../utility/utils";
import { fetchCustomerGreenClassifications } from "../../redux/actions/CustomerGreenClassificationActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { createAutocompleteOptions } from "../../utility/utils";
import ConfirmDialog from "../ConfirmDialog";

const validationSchema = Yup.object({
  segmentLOBId: Yup.number().min(1, "Required").required("Required"),
  customerId: Yup.number().min(1, "Required").required("Required"),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: CustomerGreenClassificationModel;
};

const CustomerGreenClassificationForm = ({
  mode,
  handleModalClose,
  data,
}: Props) => {
  const initialValues = useMemo(
    () => ({
      segmentLOBId: 0,
      customerId: 0,
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);
  const allCustomers = useAppSelector((state) => state.customer.all_Customers);
  const allSegmentLOBs = useAppSelector(
    (state) => state.segmentLOB.all_SegmentLOBs
  );

  const customerOptions = useMemo(() => {
    return createAutocompleteOptions(allCustomers, "customerId", "name");
  }, [allCustomers]);

  const segmentLOBOptions = useMemo(() => {
    return createAutocompleteOptions(allSegmentLOBs, "segmentlobid", "name");
  }, [allSegmentLOBs]);

  useEffect(() => {
    if (mode === "delete" && data) {
      setFormState(() => ({
        segmentLOBId: data.segmentLobid,
        customerId: data.customerId,
        status: data.customerGreenClassification1 ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: CustomerGreenClassificationModel = {
        segmentLobid: 0,
        customerId: 0,
        customerGreenClassification1: true,
        isActive: true,
        createdDate: new Date(),
      };
      if (mode === "add") {
        formData.segmentLobid = values.segmentLOBId;
        formData.customerId = values.customerId;
        // formData.customerGreenClassification1 =
        //   values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          segmentLobid: values.segmentLOBId,
          customerId: values.customerId,
          // customerGreenClassification1:
          //   values.status === "active" ? true : false,
        };
      }
      mode === "delete"
        ? await CustomerGreenClassificationService.deleteCustomerGreenClassification(
            formData
          )
        : await CustomerGreenClassificationService.createCustomerGreenClassification(
            formData
          );
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchCustomerGreenClassifications());
      displayToast(
        `Customer Green Classifiaction ${
          mode === "add" ? "created" : "deleted"
        } successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            {mode === "delete" ? (
              <ConfirmDialog handleModalClose={handleModalClose} />
            ) : (
              <Stack gap={2}>
                <FormikControl
                  control="autocomplete"
                  options={segmentLOBOptions}
                  name="segmentLOBId"
                  size="small"
                  label="Segment LOB"
                  placeholder="Select Segment LOB"
                />
                <FormikControl
                  control="autocomplete"
                  options={customerOptions}
                  name="customerId"
                  size="small"
                  label="Customer"
                  placeholder="Select Customer"
                />
                {/* <FormikControl
                  control="autocomplete"
                  options={statusOptions}
                  name="status"
                  size="small"
                  label="Status"
                  placeholder="Select Status"
                /> */}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={formik.isSubmitting}
                >
                  Submit
                </Button>
              </Stack>
            )}
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default CustomerGreenClassificationForm;
